import { service } from '@ember/service';

import type { Coredata, Service } from 'webapp-types';
import { BillingFeature } from 'webapp/enums/enums';

import DataLoaderBase from 'webapp/data-loader/base';

import { AppType as VersionCheckerAppType } from 'webapp/services/version-checker';

export default class DataLoaderSharedArtifact extends DataLoaderBase {
	@service('connect') declare connectService: Service.Connect;

	initialRequestsPromise = Promise.resolve();

	loadGlobals(allData: Coredata.Shared): void {
		const {
			apiUrl,
			debugParam,
			aiBffUrl,
			authServiceUrl,
			amaBackendUrl,
			accountServiceUrl,
			websiteUrl,
			isWhiteLabelingEnabled,
			whiteLabeling,
			version,
			...constants
		} = allData;

		this.requestService.apiUrl = apiUrl;
		this.requestService.debugParam = debugParam;
		this.requestService.aiBffUrl = aiBffUrl;
		this.requestService.authServiceUrl = authServiceUrl;
		this.requestService.amaBackendUrl = amaBackendUrl;
		this.requestService.websiteUrl = websiteUrl;

		this.accountService.accountServiceUrl = accountServiceUrl;

		this.billingService.updateFeatureInfo({
			[BillingFeature.WHITE_LABELING]: !!isWhiteLabelingEnabled,
		});

		this.accountService.updateWhitelabelData(whiteLabeling);

		this.connectService.initialize();

		this.versionCheckerService.version = version;
		this.versionCheckerService.appType = VersionCheckerAppType.GENERAL;

		// all the rest: constants
		this.constantsService.update(constants);

		// analytics
		this.analyticsService.initializeFromEnv();
	}

	doInitialRequests(): Promise<void> {
		return Promise.resolve();
	}

	afterInitialRequests(_initialRouteTo: string): Promise<void> {
		return Promise.resolve();
	}
}
